<template lang="html">
  <div class="navbar-container">
    <auth-modal v-if="!currentUser"></auth-modal>

    <b-navbar
      toggleable="sm"
      type="dark"
      variant="unstitched"
      class="navbar-expand-md justify-content-between"
    >
      <b-container fluid="lg">
        <b-navbar-brand
          :to="{ name: 'Root' }"
          class="mx-auto mx-md-0 order-0 order-md-1"
        >
          Unstitched
        </b-navbar-brand>

        <b-navbar
          id="nav_dropdown_collapse"
          class="w-50 order-2 pr-0"
          v-if="!detectMobile()"
        >
          <b-navbar-nav class="ml-auto" v-if="!currentUser">
            <div class="nav-buttons">
              <div class="nav-text">{{ mouseoverText }}</div>

              <b-navbar-nav>
                <b-nav-item
                  class="link"
                  :to="{ name: 'DiscoverCapsules' }"
                  @mouseenter="toggleMouseoverText(discoverText)"
                  @mouseleave="toggleMouseoverText('')"
                >
                  <i class="pe-7s-gleam nav-icon nav-icon-pe nav-icon-home"></i>
                </b-nav-item>
                <b-nav-item
                  class="link"
                  :to="{ name: 'Blog' }"
                  @mouseenter="toggleMouseoverText(blogText)"
                  @mouseleave="toggleMouseoverText('')"
                >
                  <i class="pe-7s-notebook nav-icon nav-icon-pe"></i>
                </b-nav-item>
                <b-nav-item
                  class="link"
                  :to="{ name: 'Community' }"
                  @mouseenter="toggleMouseoverText(communityText)"
                  @mouseleave="toggleMouseoverText('')"
                >
                  <i class="pe-7s-joy nav-icon nav-icon-pe"></i>
                </b-nav-item>
                <b-nav-item
                  class="auth-link"
                  v-on:click="clickOpenAuthModal"
                  @mouseenter="toggleMouseoverText(loginText)"
                  @mouseleave="toggleMouseoverText('')"
                >
                  <i class="pe-7s-unlock nav-icon nav-icon-pe"></i>
                </b-nav-item>
              </b-navbar-nav>
            </div>
          </b-navbar-nav>

          <b-navbar-nav class="ml-auto" v-else>
            <div class="nav-buttons">
              <div class="nav-text">{{ mouseoverText }}</div>

              <b-navbar-nav>
                <b-nav-item
                  class="link"
                  :to="{ name: 'DiscoverCapsules' }"
                  @mouseenter="toggleMouseoverText(discoverText)"
                  @mouseleave="toggleMouseoverText('')"
                >
                  <i class="pe-7s-gleam nav-icon nav-icon-pe nav-icon-home"></i>
                </b-nav-item>
                <b-nav-item
                  class="link"
                  :to="{
                    name: 'StitchedOutfits',
                    params: { username: currentUsername }
                  }"
                  @mouseenter="toggleMouseoverText(stitchedOutfitsText)"
                  @mouseleave="toggleMouseoverText('')"
                >
                  <i class="fi flaticon-020-heart nav-icon"></i>
                </b-nav-item>

                <b-nav-item
                  class="link"
                  :to="{
                    name: 'WardrobeClothes',
                    params: { username: currentUsername }
                  }"
                  @mouseenter="toggleMouseoverText(wardrobeText)"
                  @mouseleave="toggleMouseoverText('')"
                >
                  <i class="fi flaticon-024-dummy nav-icon"></i>
                </b-nav-item>

                <b-nav-item
                  class="link"
                  :to="{
                    name: 'Tailor',
                    params: { username: currentUsername }
                  }"
                  @mouseenter="toggleMouseoverText(tailorText)"
                  @mouseleave="toggleMouseoverText('')"
                >
                  <i class="fi flaticon-015-pincushion nav-icon"></i>
                </b-nav-item>

                <b-nav-item-dropdown
                  right
                  no-caret
                  class="link"
                  @mouseenter.native="toggleMouseoverText(currentUsername)"
                  @mouseleave.native="toggleMouseoverText('')"
                >
                  <i
                    class="pe-7s-user nav-icon nav-icon-pe user-icon nav-icon-user"
                    aria-hidden="true"
                    slot="text"
                  ></i>
                  <b-dropdown-item
                    :to="{
                      name: 'Account',
                      params: { username: currentUsername }
                    }"
                    exact
                  >
                    Account
                  </b-dropdown-item>

                  <b-dropdown-item :to="{ name: 'Community' }">
                    Community
                  </b-dropdown-item>
                  <b-dropdown-item :to="{ name: 'Blog' }">
                    Blog
                  </b-dropdown-item>
                  <b-dropdown-divider />
                  <b-dropdown-item
                    :to="{ name: 'LogOut' }"
                    @click.native="logoutUser"
                    >Logout</b-dropdown-item
                  >
                </b-nav-item-dropdown>
              </b-navbar-nav>
            </div>
          </b-navbar-nav>
        </b-navbar>
      </b-container>
    </b-navbar>
  </div>
</template>

<script>
import AuthModal from "@/components/formModal/AuthModal";
import MiscUtils from "@/utils/MiscUtils";
import { mapActions, mapGetters } from "vuex";
import { bus } from "@/main";

export default {
  components: {
    AuthModal,
  },

  created() {
    this.detectMobile = MiscUtils.detectMobile;
  },

  data() {
    return {
      mouseoverText: "",
      discoverText: "Discover",
      loginText: "Login",
      stitchedOutfitsText: "Stitched Outfits",
      tailorText: "Capsule Builder",
      wardrobeText: "Wardrobe",
      communityText: "Community",
      blogText: "Blog",
    };
  },

  computed: {
    ...mapGetters(["currentUser"]),

    currentUsername() {
      if (this.currentUser) {
        return this.currentUser.username;
      }
    },
  },

  methods: {
    ...mapActions(["logoutUser"]),

    clickOpenAuthModal() {
      bus.$emit("openSignUpModal");
    },

    toggleMouseoverText(text) {
      return (this.mouseoverText = text);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";

$font-dir: "~@/assets/fonts/";

@font-face {
  font-family: "Lombok";
  src: url("#{$font-dir}Lombok/Lombok.eot");
  src: url("#{$font-dir}Lombok/Lombok.eot?#iefix") format("embedded-opentype"),
    url("#{$font-dir}Lombok/Lombok.woff") format("woff"),
    url("#{$font-dir}Lombok/Lombok.ttf") format("truetype");
  font-weight: 400;
  font-style: normal;
}

.navbar-container {
  margin-bottom: 30px;
}

.navbar-brand {
  font-family: "Lombok";
  text-transform: uppercase;
  text-decoration: none;
  margin-bottom: -5px;
  font-size: 1.6rem;

  &:hover {
    color: $primary-accent;
  }
}

.nav-buttons {
  margin: auto;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  text-transform: uppercase;
}

.nav-text {
  color: white;
  margin: auto 0;
  margin-right: 20px;
  text-decoration: none;
  font-weight: 400;
  font-size: 12px;
  letter-spacing: 1px;
  text-align: right;
}

.link {
  text-decoration: none;
  color: #fff;

  &:hover {
    color: $primary-accent;
  }

  .user-icon {
    vertical-align: middle;
  }
}

.auth-link {
  .nav-link {
    color: #fff !important;
  }

  &:hover {
    .nav-link {
      color: $primary-accent !important;
    }
  }
}

.nav-link {
  .nav-icon {
    color: #fff;
    font-size: 20px;

    &.nav-icon-pe {
      font-size: 22px;
      margin-top: 4px;
    }

    &.nav-icon-home {
      margin-top: 2px;
    }

    &.nav-icon-user {
      margin-top: 2px;
    }

    &:hover {
      color: $primary-accent;
    }
  }

  &.router-link-active {
    .nav-icon {
      color: $primary-accent;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header/Navbar.vue